import { FC, useId } from 'react';
import { StyledSelectWrapper, StyledSelect } from './styled';

type Option = {
  label: string;
  value: string;
};

type Props = {
  label?: string;
  placeholder?: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  disabled?: boolean;
};

const Select: FC<Props> = ({
  label,
  placeholder,
  value,
  options,
  onChange,
  disabled = false,
}) => {
  const id = useId();

  return (
    <StyledSelectWrapper>
      {label && <label htmlFor={id}>{label}</label>}
      <StyledSelect
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
    </StyledSelectWrapper>
  );
};

export default Select;
